import React, { useEffect, useState } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';

function ErrorModal({ header, message, errorAcknowledgeResult }) {
    const [timestamp, setTimestamp] = useState('');

    useEffect(() => {
        const now = new Date();
        const formatted = now.toLocaleString(); // e.g., "12/1/2025, 2:45:30 PM"
        setTimestamp(formatted);
    }, []);

    const clickResult = (result) => {
        errorAcknowledgeResult(result);
    };

    return (
        <div className='modal-container' style={{ height: "225px", maxWidth: "400px" }}>
            <button className='modal-close-button' onClick={() => clickResult(false)}>
                <Cross2Icon width='30px' height='30px' />
            </button>
            <div className='modal-header'>{header}</div>
            <div className='modal-content'>
                <div style={{ fontSize: '18px' }}>{message}</div>
            </div>
            <div style={{ fontSize: '14px', color: 'gray', textAlign: 'center', margin: '10px 0' }}>
                {timestamp}
            </div>
            <div className="modal-footer">
                <button className="button" style={{ width: '100px' }} onClick={() => clickResult(true)}>Okay</button>
            </div>
        </div>
    );
}

export default ErrorModal;
